import { ProtocolTypes } from '@/models/bud'

const categories = state => state.categories

const protocolsResult = state => state.protocolsResult

const currentProtocol = state => state.currentProtocol

const lastHistoryId = state => channelId => {
  return state.history[channelId]?.[state.history[channelId].length - 1]
}

const showCategories = state => !state.currentProtocol

const showProtocol = state =>
  [ProtocolTypes.SCRIPT, ProtocolTypes.QUESTION, ProtocolTypes.BUS].includes(
    state.currentProtocol?.serviceScriptNode.type
  )

const loading = state => state.loading

const sentToChannels = state => state.sentToChannels

const navigationHistory = state => state.navigationHistory

export default {
  categories,
  protocolsResult,
  currentProtocol,
  lastHistoryId,
  showCategories,
  showProtocol,
  loading,
  sentToChannels,
  navigationHistory
}
